import { gql } from '@apollo/client';

export const GET_RECORDING_DOWNLOAD_URL = gql`
  query Query($recordingId: MongoObjectID!) {
    getMyRecording(id: $recordingId) {
      downloadUrl
    }
  }
`;
